import { Flex, FormControl, FormLabel, IconButton } from "@chakra-ui/react";
import { Controller, useFormContext } from "react-hook-form";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { ptBR } from 'date-fns/locale';
import { IoChevronBackCircleOutline, IoChevronForwardCircleOutline } from "react-icons/io5";
import { InputSearch } from "../../components/Form/InputSearch";

registerLocale('ptBR', ptBR)


export function SearchDate(){
  const { control } = useFormContext();

  return (
    <FormControl maxWidth={{
        xs: 'full',
        lg: '12rem'
      }} w={"100%"}>
        <FormLabel mb={0}>Data</FormLabel>
        <Controller
              name="data_saida"
              control={control}
              render={({ field: { onChange, onBlur, ref, value, name } }) => ( 
              <DatePicker
                selectsDisabledDaysInRange
                value={value || null}
                onChange={onChange} 
                onBlur={onBlur} 
                ref={ref} 
                name={name} 
                locale={"ptBR"}
                selected={value}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                minDate={new Date()}
                customInput={<InputSearch value={value || ""} name={name} ref={ref} type="text" />}
                renderCustomHeader={({
                  monthDate,
                  customHeaderCount,
                  decreaseMonth,
                  increaseMonth,
                }) => (
                <Flex justifyContent={'space-between'} alignItems={'center'} backgroundColor={'#e0cf0b'}>
                  <IconButton
                    aria-label="Mês Anterior"
                    variant={'unstyled'}
                    display={'flex'}
                    icon={<IoChevronBackCircleOutline size={24} />}
                    style={customHeaderCount === 1 ? { visibility: "hidden" } : undefined}
                    onClick={decreaseMonth}
                    _hover={{ color: "gray" }}
                  />
                  <span className="react-datepicker__current-month">
                    {monthDate.toLocaleString("pt-BR", {
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                  <IconButton
                    aria-label="Mês Posterior"
                    variant={'unstyled'}
                    icon={<IoChevronForwardCircleOutline size={24} />}
                    style={customHeaderCount === 0 ? { visibility: "hidden" } : undefined}
                    onClick={increaseMonth}
                    _hover={{ color: "gray" }}
                  />
                </Flex>
              )}
              monthsShown={2}
              
              />
            )}
        />
    </FormControl>
  )
}